import  { createContext, useContext } from "react";

const SmsProviderDetailContext = createContext();

const useSmsProviderDetailContext = () => {
  const context = useContext(SmsProviderDetailContext);
  if (!context) {
    throw new Error(
      "useSmsProviderDetailContext must be used within a SmsProviderDetailContext.Provider"
    );
  }
  return context;
};

export { SmsProviderDetailContext, useSmsProviderDetailContext };